# Termini e Condizioni

*Ultimo aggiornamento: 24 ottobre 2026*

I presenti Termini e Condizioni ("Termini") disciplinano l'accesso e l'utilizzo della piattaforma web **kart.win** ([https://kart.win](https://kart.win)) e dell'applicazione mobile **Kart Win Extractor** (`com.yanicksenn.telemetry.extractor`) gestite da **Yanick Senn** ("noi", "ci" o "nostro", collettivamente i "Servizi").

Effettuando l'accesso o utilizzando i Servizi, oppure facendo clic su "Accetta", accetti di essere vincolato dalla versione corrente dei presenti Termini.

---

## 1. Ambito di applicazione e accettazione

1. **Obbligo di accettazione**: Ogni utente autenticato deve accettare l'ultima versione dei presenti Termini prima di eseguire qualsiasi azione autenticata all'interno dei Servizi.
2. **Aggiornamenti di versione**: Ogni volta che i presenti Termini vengono aggiornati in una nuova versione, ti verrà richiesto di esaminare e accettare i Termini aggiornati prima di continuare a utilizzare le funzionalità che richiedono l'autenticazione.
3. **Informativa sulla privacy**: L'utilizzo dei Servizi è inoltre disciplinato dalla nostra [Informativa sulla privacy](#/privacy), che spiega come raccogliamo, conserviamo e proteggiamo i tuoi dati personali e di sessione.

---

## 2. Registrazione dell'account e uso consentito

1. **Credenziali dell'account**: Puoi accedere utilizzando i provider di identità di terze parti supportati (come Accedi con Apple o Accedi con Google). Sei responsabile del mantenimento della sicurezza del tuo account e di tutti i dispositivi connessi o delle applicazioni autorizzate.
2. **Uso consentito**: Accetti di utilizzare i Servizi esclusivamente per scopi leciti e in conformità con i presenti Termini. Non devi:
   - Tentare di ottenere accesso non autorizzato agli account, ai team o ai dati privati di altri utenti;
   - Interferire con, interrompere o sovraccaricare i Servizi, i server o le reti;
   - Effettuare reverse engineering, decompilare o abusare di qualsiasi parte dei Servizi o delle relative API; oppure
   - Caricare codice malevolo, archivi corrotti o contenuti illeciti.
3. **Sospensione o chiusura dell'account**: Ci riserviamo il diritto di sospendere o interrompere l'accesso ai Servizi in qualsiasi momento qualora ritenessimo ragionevolmente che tu abbia violato i presenti Termini o compromesso la sicurezza o l'integrità della piattaforma.

---

## 3. Dati dell'utente e licenza sui contenuti

1. **Proprietà**: Mantieni tutti i diritti di proprietà sui dati, sui file, sulle configurazioni e sui contenuti che carichi o inserisci nei Servizi ("Contenuti dell'utente").
2. **Licenza per l'erogazione dei Servizi**: Caricando o inviando Contenuti dell'utente nei Servizi, ci concedi una licenza mondiale, non esclusiva e gratuita per ospitare, archiviare, elaborare, analizzare e visualizzare tali Contenuti dell'utente esclusivamente allo scopo di fornire, mantenere e migliorare i Servizi per te e per eventuali team o utenti con cui scegli di condividere i tuoi dati.
3. **Condivisione con il team**: Quando ti unisci a un team o condividi esplicitamente dei dati con un team all'interno dei Servizi, i membri di tale team avranno accesso alla visualizzazione dei dati condivisi in conformità con le tue impostazioni di condivisione.

---

## 4. Disponibilità del servizio ed esclusione di garanzie ("Così com'è")

1. **Fornito "Così com'è"**: I Servizi e tutti i relativi report, visualizzazioni, calcoli e raccomandazioni sono forniti **"COSÌ COME SONO" ("AS IS")** e **"SECONDO DISPONIBILITÀ" ("AS AVAILABLE")**, senza garanzie di alcun tipo, siano esse esplicite, implicite o di legge.
2. **Nessuna garanzia di disponibilità o accuratezza**: Pur impegnandoci per garantire un'elevata affidabilità, non garantiamo che i Servizi siano ininterrotti, privi di errori o completamente accurati in ogni momento, né garantiamo l'archiviazione o il backup a tempo indeterminato dei Contenuti dell'utente.

---

## 5. Limitazione di responsabilità

Nella misura massima consentita dalla legge applicabile:

1. **Esclusione dei danni indiretti**: In nessun caso **Yanick Senn** sarà responsabile per danni indiretti, incidentali, speciali, consequenziali o punitivi, né per qualsiasi perdita di dati, ricavi, profitti o avviamento derivante da o correlata all'uso o all'impossibilità di usare i Servizi.
2. **Responsabilità massima**: La nostra responsabilità cumulativa totale per qualsiasi reclamo derivante da o relativo ai presenti Termini o ai Servizi non potrà superare l'importo totale da te eventualmente corrisposto per l'utilizzo dei Servizi nei dodici (12) mesi precedenti l'evento che ha dato origine al reclamo.

---

## 6. Legge applicabile e foro competente

I presenti Termini e qualsiasi controversia o pretesa derivante da o connessa agli stessi o ai Servizi sono disciplinati e interpretati in conformità con il diritto sostanziale della **Svizzera**, con esclusione delle norme sul conflitto di leggi. Il foro competente esclusivo è quello dei tribunali competenti presso il domicilio del gestore in Svizzera, fatti salvi eventuali fori imperativi previsti dalla legge.

---

## 7. Contatti

Per qualsiasi domanda riguardante i presenti Termini e Condizioni, puoi contattare:

- **Gestore**: Yanick Senn
- **Email**: [info@yanicksenn.com](mailto:info@yanicksenn.com)
- **Sito web**: [https://kart.win](https://kart.win)
